export const clearSpace = (str: string) => str.replace(/\s/g, '');
